import React from 'react';
import classNames from 'classnames';

export default function LessIcon({ className = '' }) {
	return <span className={classNames('icon icon-less_sign', className)} />;
}
